import Store from '@mjcloud/redux';
import Reduce from './reduce';
import { DataModeEnum } from '@mjcloud/types';
import StatisticsExtendStore from './extendStore';
import { ContainerDataInstanceBase } from '@mjcloud/instance';

export default class Statistics extends ContainerDataInstanceBase {
  __createStore() {
    return new Store({
      id: this.id,
      reduce: Reduce,
      extendStore: new StatisticsExtendStore(this),
    });
  }

  getDataMode() {
    return DataModeEnum.all;
  }

  initialState(initConfig) {
    this.store.dispatch('configStartLoad', {
      initConfig,
    });
  }

  createControl(config) {
    return this.__createControl(config.id, config);
  }
}
